'use client'

import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'

import { useOnMount } from '@src/hooks/useOnMount'
import { STORAGE } from '@src/utils/constants.util'
import { storage } from '@src/utils/storage.util'

interface SSEOrder {
  isUpComingOrder: boolean
}

export function UpcomingOrdersIndicator() {
  const [upcomingOrders, setUpcomingOrders] = useState(0)
  const pathname = usePathname()

  // Clear stored upcoming orders on mount
  useOnMount(() => {
    storage.session.remove(STORAGE.sseOrders)
  })

  // Load upcoming orders from storage and update the indicator
  useEffect(() => {
    function readUpcomingOrders() {
      try {
        const orders: SSEOrder[] = storage.session.get(STORAGE.sseOrders)
        setUpcomingOrders(orders.filter((order: any) => !!order.isUpComingOrder).length)
      } catch (error) {
        setUpcomingOrders(0)
      }
    }

    readUpcomingOrders()
    window.addEventListener('storage', readUpcomingOrders)
    return () => window.removeEventListener('storage', readUpcomingOrders)
  }, [pathname])

  return upcomingOrders > 0 ? (
    <div className="mb-4 size-[6px] rounded-full bg-bodi-red-deep-500" />
  ) : null
}
